<template>
  <div class="category" @click="setActiveRoom">
    <p class="heading" v-text="category.name"></p>
    <OrderSummaryCategoryProduct
      v-for="product in category.products"
      :key="product.id"
      :product="product"
      :room="room"
    />
  </div>
</template>

<script>
import OrderSummaryCategoryProduct from './OrderSummaryCategoryProduct';

export default {
  name: 'OrderSummaryCategory',
  components: {
    OrderSummaryCategoryProduct,
  },
  props: {
    category: {
      required: true,
      type: Object,
    },
    room: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    setActiveRoom() {
      this.$store.commit('build/setActiveRoom', this.room);
    },
  },
};
</script>
